import React, { useState, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Permissions } from '@whatsper/texterchat-common';
import ResolveChatsMenu from '../../ResolveChatsBlock/ResolveChatsMenu';
import { CHATS_GROUP } from '../../../../store/ChatsStore';
import { useStore } from '../../../../store/rootStore';
const createExtraActionsMenu = ({ resolve, totalCount }) => {
    const [showResolveMenu, setShowResolveMenu] = useState(false);
    const containerRef = useRef(null);
    const { t } = useTranslation();
    const { agentsStore, chatsStore } = useStore();
    const menu = () => {
        const items = [];
        if (agentsStore.hasPermissions([Permissions.Permission.chats_bulk_resolve])) {
            items.push({
                key: 'resolve-chats',
                label: (React.createElement(Trans, { i18nKey: 'resolveChats', values: {
                        status: chatsStore.currentGroup === CHATS_GROUP.PENDING ? t('pending') : t('taken'),
                    } })),
                onClick: (e) => {
                    var _a;
                    (_a = e === null || e === void 0 ? void 0 : e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                    setShowResolveMenu(true);
                },
                disabled: !resolve || totalCount === 0,
            });
        }
        return { items };
    };
    const MenuComponent = () => (React.createElement("div", { ref: containerRef },
        React.createElement(ResolveChatsMenu, { visible: showResolveMenu, onHide: () => setShowResolveMenu(false), containerRef: containerRef })));
    return { menu: menu(), MenuComponent };
};
export default createExtraActionsMenu;
